import { Injectable } from '@angular/core';
import { Http,Response, Headers,RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/catch';
import {Observable} from "rxjs";
import {OrdenCompra} from "../orden-compra/ordenCompra";
import {AuthenticationService} from "../Login/authentication.service";
import {UrlService} from "./url.service";



@Injectable()
export class OrdenCompraService
{

  private headers = new Headers({'Content-Type':'application/json',
    'Authorization': 'Bearer ' + this.authenticationService.token  });//parametrizamos a json
  private options = new RequestOptions({ headers: this.headers });
  private url = this.URL.getLocal()+'/ordencompra';//Url que maeja GET ,POST
  private urlDetByOrdenCompra = this.URL.getLocal()+'/detalleorden/';//busca los archivos de un Traslado por id
  private urlPagoByOrdenCompra = this.URL.getLocal()+'/pagoorden/';//busca los archivos de un Traslado por id
  private urlAddPago = this.URL.getLocal()+'/pagoorden';//busca los archivos de un Traslado por id
  private urlAddDetalle = this.URL.getLocal()+'/detalleorden';//busca los archivos de un Traslado por id
  private urlPut = this.URL.getLocal()+'/ordencompra/';//la direccion a la cual se conecta
  private urlPutDetalle = this.URL.getLocal()+'/detalleorden/';//la direccion a la cual se conecta


  //Constructor de la clase
  constructor(private URL:UrlService,private http:Http, private authenticationService: AuthenticationService)
  {
    //this.headers.append('Content-Type', 'application/x-www-form-urlencoded');
    //this.headers.append('X-Requested-With', 'XMLHttpRequest');
  }
  //Obtiene una lista de OrdenCompras
  getOrdenCompra():Observable<OrdenCompra[]> {
    let url = `${this.url}`;
    return this.http.get(url,this.options)
      .map(r => r.json())
      .catch(this.handleError)
  }
  getDetallesByOrden(id: number): Observable<any[]> {
    let url = `${this.urlDetByOrdenCompra}${id}`;
    return this.http.get(url, this.options)
      .first()
      .map(r => r.json())
      .catch(this.handleError)
  }
  getPagosByOrden(id: number): Observable<any[]> {
    let url = `${this.urlPagoByOrdenCompra}${id}`;
    return this.http.get(url, this.options)
      .first()
      .map(r => r.json())
      .catch(this.handleError)
  }
  addDetalleOrdenCompra(dato:any) {
    let url = `${this.urlAddDetalle}`;
    let iJson = JSON.stringify(dato);
    return this.http.post(url,iJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);

  }
  addPagoOrdenCompra(dato:any) {
    let url = `${this.urlAddPago}`;
    let iJson = JSON.stringify(dato);
    return this.http.post(url,iJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);

  }

  addOrdenCompra(OrdenCompra:OrdenCompra) {
    let url = `${this.url}`;
    let iJson = JSON.stringify(OrdenCompra);
    return this.http.post(url,iJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);

  }
  putOrdenCompra(OrdenCompra : OrdenCompra,id:number){
    let url = `${this.urlPut}${id}`;
    let CJson = JSON.stringify(OrdenCompra);
    return this.http.put(url,CJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);
  }
  putDetalleOrdenCompra(datos : any,id:number){
    let url = `${this.urlPutDetalle}${id}`;
    let CJson = JSON.stringify(datos);
    return this.http.put(url,CJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);
  }
//Este metodo detecta un error en la llamada a http
  private handleError(error : Response | any) {
    let errMsj : string;
    if(error instanceof Response)
    {
      let body  = error.json() || '';
      let err = body.error || JSON.stringify(body);
      errMsj = `${error.status} - ${error.statusText || ''} ${err}`;
    }
    else
    {
      errMsj = error.message ? error.message : error.Tostring();
    }
    return Observable.throw(errMsj);
  }
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/Services/ordenCompra.service.ts